import React from "react";
import { STATUS_META } from "@/lib/brand";
import { useApp } from "@/context/AppContext";

export function StatusBadge({ status }) {
  const { lang } = useApp();
  const meta = STATUS_META[status] || { en: status, it: status, color: "#A39E93" };
  return (
    <span
      data-testid="member-status-badge"
      className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[0.7rem] font-mono-cu uppercase tracking-[0.15em]"
      style={{ color: meta.color, border: `1px solid ${meta.color}55`, background: `${meta.color}12` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta[lang] || meta.en}
    </span>
  );
}
